import { gql, useQuery } from '@apollo/client';

import { GetApiKeys } from './__generated__/GetApiKeys';

export const GET_APIKEYS = gql`
  query GetApiKeys {
    viewer {
      apiKeys {
        id
        name
        deactivatedAt
      }
    }
  }
`;

export default function useGetApiKeys() {
  const { data, error, loading } = useQuery<GetApiKeys>(GET_APIKEYS);
  const apiKeys = data?.viewer?.apiKeys ?? [];
  return { apiKeys, error, loading };
}
